import { domain } from '@utils/constants';
import Cookies from 'js-cookie';

const isProduction = domain == 'flyflapper.com';

const defaultCookieOptions = {
  domain: isProduction ? `.${domain}` : '',
  path: '/',
  sameSite: 'lax',
  secure: isProduction ? true : false,
};

export const acceptGDPRCookies = (cookies = []) => {
  cookies.forEach(cookie => {
    setCookie(cookie, true, 90);
  });
};

export const declineGDPRCookies = (cookies = []) => {
  cookies.forEach(cookie => {
    setCookie(cookie, false, 90);
  });
};

export const setCookiesConsent = state => {
  localStorage.setItem('cookiesConsent', state);
};

export const setCookie = (name, value, exirationDays) => {
  Cookies.set(name, value, {
    ...defaultCookieOptions,
    expires: exirationDays * 24 * 60 * 60 * 1000,
  });
};

export const removeCookie = (name, path) => {
  Cookies.remove(name, {
    ...defaultCookieOptions,
  });
};

export const getCookie = name => {
  const value = Cookies.get(name) || '';

  return value;
};
